import { Text, HStack, Stack, VStack } from '@genial/components';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { ButtonSkeleton, TextSkeleton } from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';
import { clubsTableHead } from '../constants';

export const ListLoadingItemTablet: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  const bottomInfos = [
    { label: clubsTableHead[1].title, value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: clubsTableHead[3].title, value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: clubsTableHead[4].title, value: <TextSkeleton w="60%" />, maxW: '24%' },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs">
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius="sm"
        borderBottomLeftRadius="sm"
      />
      <VStack padding="inset.sm" space="stack.xxxs" w="full">
        <TextSkeleton w="60%" />
        <HStack justifyContent="space-between">
          {bottomInfos.map(({ label, value, maxW }) => (
            <VStack maxW={maxW} space="stack.quarck" key={label}>
              <Text color="neutral.black" variant="semibold">
                {label}
              </Text>
              {value}
            </VStack>
          ))}
          <Stack alignSelf="flex-end" w="20%">
            <ButtonSkeleton />
          </Stack>
        </HStack>
      </VStack>
    </TableContent>
  );
};
